import React from 'react'
import CompanyCertification from '../../Components/Verify Certificate/CompanyCertification'

const CompanyCertificationMainpage = () => {
  return (
    <div>
      <CompanyCertification/>
    </div>
  )
}

export default CompanyCertificationMainpage
